// NOTE: separated to prevent circular dependency in static/prompts and static/trendbaby-tools

export const TRENDBABY_TOOL_IDS = {
  IndustryReport: "IndustryReport",
  RegionReport: "RegionReport",
  ScenarioOOH: "ScenarioOOH",
  ProductLab: "ProductLab",
  CampaignCrafter: "CampaignCrafter",
  ProductBoost: "ProductBoost",
  AGIVentures: "AGIVentures",
  TrendCheck: "TrendCheck",
  Regionall: "Regionall",
} as const

export type TrendBabyToolId = (typeof TRENDBABY_TOOL_IDS)[keyof typeof TRENDBABY_TOOL_IDS]
